var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7679 3C12.5378 1.66667 14.4623 1.66667 15.2321 3L23.4593 17.25C24.2291 18.5833 23.2668 20.25 21.7272 20.25H5.27276C3.73316 20.25 2.77091 18.5833 3.54071 17.25L11.7679 3Z",
    fill: "#B20000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6.625L14.4922 14.5234H12.6172L12.3516 6.625H14.75ZM12.2891 16.9688C12.2891 16.6354 12.4036 16.3594 12.6328 16.1406C12.8672 15.9167 13.1745 15.8047 13.5547 15.8047C13.9401 15.8047 14.2474 15.9167 14.4766 16.1406C14.7057 16.3594 14.8203 16.6354 14.8203 16.9688C14.8203 17.2917 14.7057 17.5651 14.4766 17.7891C14.2474 18.013 13.9401 18.125 13.5547 18.125C13.1745 18.125 12.8672 18.013 12.6328 17.7891C12.4036 17.5651 12.2891 17.2917 12.2891 16.9688Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconRed);
export default __webpack_public_path__ + "static/media/warningIconRed.585e50fb0f451efee44cd644ce85d3e1.svg";
export { ForwardRef as ReactComponent };